import _createClass from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { captureException } from '@sentry/nextjs';
import { ErrorCode } from '@ethersproject/logger';
import i18n from "../i18n";
import { message } from "../components/Message";
import { isClient } from "./userAgent";
export var TxError = /*#__PURE__*/function (_Error) {
  _inherits(TxError, _Error);

  var _super = _createSuper(TxError);

  function TxError(code) {
    var _this;

    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _classCallCheck(this, TxError);

    _this = _super.call(this, message);
    _this.code = code;
    _this.message = message;
    return _this;
  }

  return _createClass(TxError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var handleTxError = function handleTxError(error) {
  var t = i18n.t;

  if (error instanceof Error) {
    var e = error;
    var errorCode = e.code;

    switch (errorCode) {
      case ErrorCode.UNKNOWN_ERROR:
      case ErrorCode.NOT_IMPLEMENTED:
      case ErrorCode.UNSUPPORTED_OPERATION:
      case ErrorCode.NETWORK_ERROR:
      case ErrorCode.SERVER_ERROR:
      case ErrorCode.TIMEOUT:
      case ErrorCode.BUFFER_OVERRUN:
      case ErrorCode.NUMERIC_FAULT:
      case ErrorCode.MISSING_NEW:
      case ErrorCode.INVALID_ARGUMENT:
      case ErrorCode.MISSING_ARGUMENT:
      case ErrorCode.UNEXPECTED_ARGUMENT:
      case ErrorCode.CALL_EXCEPTION:
      case ErrorCode.INSUFFICIENT_FUNDS:
      case ErrorCode.NONCE_EXPIRED:
      case ErrorCode.REPLACEMENT_UNDERPRICED:
      case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
      case ErrorCode.TRANSACTION_REPLACED:
        captureException('Tx Error', {
          extra: {
            errorCode: errorCode,
            error: e
          }
        });
        message.error(t("provider_error_code_".concat(errorCode)));
        break;

      default:
        if (!errorCode && !!e.message) {
          captureException('Tx Error', {
            extra: {
              error: e
            }
          });
          message.error(t(e.message));
          return;
        }

        message.error(t("provider_error_code_".concat(ErrorCode.UNKNOWN_ERROR)));
        console.error("unexpected error code: ".concat(errorCode), e);
        return;
    }
  } else if (typeof error === 'object' && error !== null && 'message' in error) {
    // catch WalletConnect imToken matchEthSendMsg error which won't be caught by error instanceof Error
    // https://github.com/consenlabs/token-v2/blob/85cd5eea1a9e7b72ce738fb806f4ad9c7e402d8f/src/global/TokenPay/helper.ts#L165-L172
    var _e = error;
    captureException('Tx Error', {
      extra: {
        error: _e.message
      }
    });
    message.error(_e.message);
  }

  if (typeof error === 'string') {
    captureException('Tx Error', {
      extra: {
        error: error
      }
    });
    message.error(error);
  }
};
export var globalTxErrorHandler = function globalTxErrorHandler() {
  if (isClient) {
    window.addEventListener('error', function (event) {
      if (event.error instanceof Error) {
        handleTxError(event.error);
      }
    });
  }
};